module.exports = __webpack_public_path__ + "img/IMG_3140.a7ea8dc6.jpg";